<div class="profile-container">
    <div class="profile-content">    
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off" >
                            <input type="text" placeholder="search" (keyup.enter)="getLocationByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                        </form>
                        <i class="bi bi-search" (click)="getLocationByWildSearch()"></i>
                    </div>
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                    <th style="width: 20%;">{{ 'asset-audit-report.financialYear' | translate }}</th>
                    <th style="width: 20%;">{{ 'asset-audit-report.auditReportDocumentName' | translate }}</th>
                    <th style="width: 20%;">{{ 'asset-audit-report.auditedByCompany' | translate }}</th>
                    <th style="width: 20%;">{{ 'asset-audit-report.auditReportSubmittedOn' | translate }}</th>
                    <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                    </tr>
                </thead>
            </table>
            <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let list of assetAuditReportList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 20%;">{{list.financialYear}}</p>
                    <p style="width: 20%;">{{list.auditReportDocumentName}}</p>
                    <p style="width: 20%;">{{list.auditedByCompany}}</p>
                    <p style="width: 20%;">{{list.auditReportSubmittedOn | date}}</p>
                
                    <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                        <i data-toggle="modal" title="View" (click)="getAssetAuditReport(list.assetAuditReportId)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                    </p>
                </div>
            </div>


            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader"  *ngIf="!isLoading && assetAuditReportList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
                
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>


        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteLocation()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-audit-report.headings.detail' | translate }}
            <span data-dismiss="modal">
                <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body">
            <div [formGroup]="assetAuditReportForm">
                <div class="form-group">
                    <label>{{ 'asset-audit-report.financialYear' | translate }} <span class="required">*</span></label>
                    <input formControlName="financialYear" type="date" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ 'asset-audit-report.auditedByCompany' | translate }} <span class="required">*</span></label>
                    <input formControlName="auditedByCompany" type="text" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ 'asset-audit-report.auditReportDocumentName' | translate }} <span class="required">*</span></label>
                    <input formControlName="auditReportDocumentName" type="text" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ 'asset-audit-report.auditReportDocumentPath' | translate }} <span class="required">*</span></label>
                    <button class="add-file" *ngIf="fileName == ''" (click)="addFileBtn()">{{ 'generic.add-file' | translate }}</button>
                    <div class="file-added" *ngIf="fileName != ''">
                        <button class="" (click)="removeFile(fileInput)">{{ 'generic.remove' | translate }}</button>
                    </div>
                    <div hidden="true">
                        <input type="file" #fileInput (change)="onChange($event,fileInput)" id="add-btn" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>

                <button type="button" (click)="addLocation()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
            </div>
        </div>
      </div>
    </div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'asset-audit-report.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body" *ngFor="let list of singleAssetAuditReportData">

        <div class="row mb-3">

        <div class="col-md-6 col-lg-6">
            <label>{{ 'asset-audit-report.financialYear' | translate }} :</label>
            <p>{{ list.financialYear || '--' }}</p>
        </div>

        <div class="col-md-6 col-lg-6">
            <label>{{ 'asset-audit-report.auditedByCompany' | translate }} :</label>
            <p>{{ list.auditedByCompany || '--' }}</p>
        </div>

        <div class="col-md-6 col-lg-6">
            <label>{{ 'asset-audit-report.auditReportSubmittedOn' | translate }} :</label>
            <p>{{ list.auditReportSubmittedOn | date }}</p>
        </div>

        <!-- <div class="col-md-6 col-lg-6 download">
            <label>Document Name:</label>
            <p><a href="{{list?.auditReportDocumentPath}}" class="" download>{{ list.auditReportDocumentName || '--' }}</a></p>
        </div> -->



        </div>
        <div class="modal-footer">
            <a href="{{list?.auditReportDocumentPath}}" class="" download><button type="button" id="" class="btn btn-success">{{ 'generic.download' | translate }}</button></a>
            
            <button type="button" id="closeModalView" (click)="clearData()" style="margin-left: 10px;" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>

    </div>
  </div>
</div>